// extracted by mini-css-extract-plugin
export default {"pt_32":"vendors_pt_32__cJmMw","search_grid":"vendors_search_grid__DJauK"};